import classNames from 'classnames';
import './NoteRowHeaderItem.scss';

interface NoteRowHeaderItemProps {
    text: string;
    tooltip?: string;
    icon: React.ReactNode;
    className?: string;
    disabled?: boolean;
}

export function NoteRowHeaderItem({
    text,
    tooltip,
    icon,
    className,
    disabled = false,
}: NoteRowHeaderItemProps) {
    return (
        <div
            className={classNames('NoteRowHeaderItem', className, {
                'NoteRowHeaderItem--disabled': disabled,
            })}
        >
            <div className="NoteRowHeaderItem__icon">{icon}</div>
            <p className="NoteRowHeaderItem__text" title={tooltip}>
                {text}
            </p>
        </div>
    );
}
